export default __webpack_public_path__ + "static/car-b8075edab7e8197d9537cd090871d34c.webp";